<template>
  <div class="min-h-full flex flex-col">
    <Menubar>
      <template #start>
        <div class="flex items-center">
          <a :href="CmsUrl">
            <img src="@/assets/images/logo.svg" alt="logo" class="px-3" />
          </a>
          <LanguageSwitcher />
        </div>
      </template>
    </Menubar>

    <div class="flex flex-col lg:flex-row flex-1 text-neutral-800 font-sans">
      <div class="flex-1 flex flex-col justify-center px-10 lg:px-[10rem] py-10">
        <h1 class="text-4xl lg:text-8xl mb-10">{{ $t('translations_for_every_need') }}</h1>
        <h4 class="max-w-[40rem] text-lg">
          {{ $t('login_page_subtitle') }}
        </h4>
      </div>

      <div class="flex flex-1 flex-col justify-stretch">
        <div
          class="flex-1 flex flex-1 flex-col justify-between bg-white px-6 xl:px-16 py-14 m-6 rounded-lg mx-10 shadow-md"
        >
          <div class="flex flex-col items-center">
            <img
              class="w-[8rem] h-[8rem] w-auto"
              src="@/assets/images/consulting.svg"
              alt="Your Company"
            />
            <h2 class="mt-4 text-5xl font-bold text-gray-900 mb-5">{{ $t('sign_up') }}</h2>
          </div>

          <RegisterForm />

          <p class="mt-4 text-sm text-center space-x-1 leading-6 text-gray-500">
            <span>{{ $t('already_have_an_account') }}</span>
            <router-link to="/login" class="font-semibold text-royal-400 hover:underline">
              {{ $t('sign_in') }}
            </router-link>
          </p>
        </div>

        <div class="text-neutral-800 text-center text-sm pb-4">
          <i18n-t keypath="terms_of_use_complete_registration">
            <template v-slot:terms>
              <router-link
                to="/terms-of-use"
                target="_blank"
                class="text-royal-400 hover:underline"
              >
                {{ $t('terms_of_use') }}
              </router-link>
            </template>
          </i18n-t>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Menubar from 'primevue/menubar'
import Button from 'primevue/button'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import RegisterForm from '@/components/forms/RegisterForm.vue'
import { SHOP_URL } from '@/entrypoint'

const CmsUrl = SHOP_URL
</script>
